import { motion } from "framer-motion";
import SectionHead from "@/components/SectionHead";
import { EASE } from "@/components/Reveal";
import { PROCESS_STEPS } from "@/lib/data";

export default function ProcessSection() {
  return (
    <section data-testid="process-section" className="relative bg-[#060B18] py-24">
      <div className="mx-auto max-w-7xl px-6">
        <SectionHead
          overline="Our Process"
          title="A Recruitment Process Built for Better Hiring."
          sub="Six structured stages — from first briefing to joining follow-up."
          testid="process-heading"
        />
        <div className="relative mx-auto max-w-3xl">
          <div className="absolute bottom-6 left-[27px] top-6 w-px bg-gradient-to-b from-sky-400/50 via-indigo-500/40 to-transparent" />
          <div className="space-y-10">
            {PROCESS_STEPS.map((s, i) => (
              <motion.div
                key={s.num}
                data-testid={`process-step-${s.num}`}
                initial={{ opacity: 0, x: -32 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.65, delay: i * 0.05, ease: EASE }}
                className="group relative flex gap-7"
              >
                <div className="relative z-10 grid h-14 w-14 shrink-0 place-items-center rounded-2xl border border-white/[0.08] bg-[#0A0F1D] font-mono text-sm font-medium text-sky-400 shadow-[0_0_0_6px_rgba(6,11,24,1)] transition-[border-color,box-shadow] duration-500 group-hover:border-sky-400/40 group-hover:shadow-[0_0_0_6px_rgba(6,11,24,1),0_0_30px_rgba(56,189,248,0.15)]">
                  {s.num}
                </div>
                <div className="pb-2 pt-1.5">
                  <h3 className="font-display text-xl font-semibold text-white">{s.name}</h3>
                  <p className="mt-2 max-w-xl text-sm leading-relaxed text-slate-400">{s.desc}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
